import Link from '$partials/global/link';
import IconArrowRight from '$partials/icons/icon-arrow-right';
import NativeImage from '$partials/media/native-image';
import { formatUrlWithActiveFund } from '$utilities/format';
import { getSiteContext } from '$utilities/site-context';
import PropTypes from 'prop-types';
import React from 'react';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @param {PropTypes.InferProps<typeof propTypes>} props
 */
const OrganisationListing = ({ sidebarTitle , items, ctaLabel, ctaLink }) => {
    const siteContext = getSiteContext();

    return (
        <div className='layout-container-padding-right flex flex-wrap max-w-container pt-70 sm:pt-80'>
            {/* Left Sidebar */}
            <div className='w-sidebar'>
                <div className='flex flex-col items-center'>
                    <h2 className='type-style-8 inline-block align-middle rotate-180 writing-mode-vertical-rl'>
                        {sidebarTitle}
                    </h2>
                </div>
            </div>

            <div className='flex-1'>
                <section className='flex-1 flex flex-wrap self-start'>
                    <div className='flex-1 layout-negative-margin'>
                        <section className='layout-item-padding'>
                            {items?.length > 0 && (
                                <ul className='w-full flex flex-wrap gap-y-40 md:gap-y-60'>
                                    {items.filter(item => !!item.logo).map((item, i) => {
                                        if (i > 15) {
                                            return null;
                                        }
                                        return (
                                            <li
                                                className='basis-6/12 sm:basis-3/12 flex items-center'
                                                key={`external-link-${i}-${item.id}`}>
                                                <Link
                                                    aria-label={item?.name}
                                                    href={item?.websiteUrl}>
                                                    {item?.logo && (
                                                        <NativeImage
                                                            className='object-contain object-left-top sm:min-w-[80px] sm:max-w-[180px] md:max-w-[260px] sm:h-30 md:h-50 w-full'
                                                            {...item.logo} />
                                                    )}
                                                    {/* {!item?.logo && (
                                                        <span
                                                            className='type-style-4'
                                                            style={{ fontWeight: '400' }}>
                                                            {item.name}
                                                        </span>
                                                    )} */}
                                                </Link>
                                            </li>
                                        );
                                    })}
                                </ul>
                            )}
                        </section>
                        <div className='mt-30 sm:mt-50 md:mt-60 layout-item-padding'>
                            {ctaLabel && ctaLink?.url && (
                                <a
                                    className='bg-grey px-12 py-5 sm:py-8 rounded-3xl h-fit arrow-button'
                                    href={formatUrlWithActiveFund(`${siteContext.branding === 'PHOENIX_COURT_WORKS' ? '/phoenix-court-works' : ''}${ctaLink.url}`)}>
                                    <span className='inline-flex items-center gap-5'>
                                        {ctaLabel}
                                        <IconArrowRight />
                                    </span>
                                </a>
                            )}
                        </div>
                    </div>


                </section>
            </div>
        </div>
    );
};

/* ========================================================================= */
/* Typing and export(s) */
/* ========================================================================= */

const propTypes = {
    sidebarTitle: PropTypes.string,
    ctaLink: PropTypes.object,
    ctaLabel: PropTypes.string,
    items: PropTypes.arrayOf(PropTypes.shape({
        name: PropTypes.string,
        websiteUrl: PropTypes.string,
        standfirst: PropTypes.string,
        logo: PropTypes.object,
    }),),
};


OrganisationListing.propTypes = propTypes;

export default OrganisationListing;
